const styles = () => ({
	container: {
		display: 'flex',
		flexFlow: 'column nowrap',
		flex: '1 1 280px',
		maxWidth: '320px',

		margin: '24px 0',

		boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
		cursor: 'pointer'
	},
	preview: {
		position: 'relative',

		width: '100%',
		height: '160px',
		overflow: 'hidden',

		backgroundColor: '#C4C4C4',
		boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)'
	},
	posterIcon: { /* overlay over poster image */
		position: 'absolute',
		top: '30%',
		left: '37.5%',
		zIndex: 5,

		width: '67px',
		height: '67px'
	},
	poster: {
		display: 'block',
		width: 'auto',
		height: '100%',
		margin: 'auto',

		backgroundSize: 'cover',
		backgroundPosition: 'top'
	},
	label: {
		display: 'flex',
		flexFlow: 'column',
		margin: '16px 6% 20px',
		height: '64px'
	},
	type: {
		margin: 0,

		fontSize: 12,
		color: '#999999'
	},
	title: {
		minHeight: 24,
		margin: 0,
		marginTop: 8,

		fontStyle: 'normal',
		fontWeight: 500,
		fontSize: 16,
		lineHeight: '21px'
	},
	'@media (min-width: 660px)': {
		container: {
			flexGrow: 0,
			width: '320px',
			marginLeft: '16px',
			marginRight: '16px'
		}
	},
	'@media (max-width: 660px)': {
		container: {
			flexGrow: 1,
			flexBasis: '280px',
			maxWidth: '100%'
		}
	}
});

export default styles;



// WEBPACK FOOTER //
// ./src/client/components/main/files/tile/styles.js